import { isNil } from 'lodash';
import { useContext } from 'react';
import { Menu } from '@shared/components/Menu';
import { CardChannelContext } from '@shared/components/blocks/contexts/channel';
import { i18n } from '@shared/util/i18n';
import { useNavigator } from '@shared/util/navigation';

interface Props {
  entityId: string;
}

export function CardHistoryMenuItem({ entityId }: Props) {
  const channel = useContext(CardChannelContext);
  const channelSlug = channel?.slug;
  const { navigate } = useNavigator();

  if (isNil(channelSlug)) {
    return null;
  }

  return (
    <Menu.Item
      label={i18n('card.menu.actions.cardHistory')}
      onClick={() => navigate('CardHistory', { cardId: entityId, channelSlug })}
    />
  );
}
